import React from "react";
import { Link } from "react-router-dom";
import Vaccine from "../components/Vaccine/Vaccine";
import Footer from "../components/Footer";

function VaccinationPage() {
  return (
    <div className="page-container">
      <div className="content-wrap">
        <Vaccine />
      </div>
    </div>
  );
}

export default VaccinationPage;
